/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import SmartsRecommenderStatus from 'util/SmartsRecommenderStatus';
import { showUnsupportedSourceTypeToast, showUnsupportedUnenrichedToast, showRelationRequestTimeoutToast } from 'util/ToastUtil';

const MEMBER_TYPE_FOCUSFILED = 'focusField';
const ERROR_CODES_CONVERTED_TO_SINGLE_NODE = [SmartsRecommenderStatus.UNSUPPORTED_MODULE_TYPE, SmartsRecommenderStatus.UNSUPPORTED_UNENRICHED_PACKAGE];
const GROUPID = 'all';


/**
* This class builds data structure locally that is sames as from the /relatonship endpoint response
*
*/
export default class DataBuilder {

	/**
	* Convert certain error code to be a local built relationship diagram response with a 'completed' status
	* (that has one node (targetID) dataset structure)
	* @param {object} ajaxResponse - response from Smarts-explore service
	@ @param {object} context - contains targetId
	*/
	static convertErrorsToCompletedResponse(ajaxResponse, context){
		const status = ajaxResponse && ajaxResponse.data && ajaxResponse.data.status;

		if(status){
			const statusCode = status.statusCode;
			if(ERROR_CODES_CONVERTED_TO_SINGLE_NODE.indexOf(statusCode) !== -1){
				const statusMsg = `Explore fallback response for error code ${statusCode}`;
				this._handleStatusObjectAsToast(context, statusCode);
				return Promise.resolve({ 'data': this.createSingleNode(context.targetID, statusMsg , null) } );
			}
		}else if(ajaxResponse && ajaxResponse.statusText){
			this._handleStatusTextAsToast(context, ajaxResponse.statusText);
		}
		return Promise.reject(ajaxResponse);
	}

	static _handleStatusObjectAsToast(context, statusCode){
		void(statusCode);
		const model = context.relationshipModel;
		if(model){
			const targetModel = model.getTargetModel();
			if(targetModel){
				targetModel.setActionErrorStatus('We were unable to show relationships because there is limited support for this data source type.');
			}
		}
	}

	static _showUnsupportedSourceTypeToast(statusCode, glassContext){
		if(statusCode === SmartsRecommenderStatus.UNSUPPORTED_MODULE_TYPE){
			showUnsupportedSourceTypeToast(glassContext);
		}else if(statusCode === SmartsRecommenderStatus.UNSUPPORTED_UNENRICHED_PACKAGE){
			showUnsupportedUnenrichedToast(glassContext);
		}
	}

	static _handleStatusTextAsToast(context, statusText){
		if(SmartsRecommenderStatus.RELATIONSHIP_REQUEST_TIMEOUT === statusText){
			showRelationRequestTimeoutToast(context.glassContext);
		}
	}

	/**
	* @param {String} targetId
	* @param {String} statusMsg
	* @param {String} statusCode
	* @param {JSONObject} predictStatusObject
	*/
	static createSingleNode(targetID, statusMsg, predictStatusObject = {}){
		return {
			'nodesDataset': {
				'targetId': targetID,
				'groupings': [{
					'groups': [{
						'groupId': `none_${targetID}`,
						'members': [{
							'id': targetID,
							'type': MEMBER_TYPE_FOCUSFILED
						}]
					}],
					'id': GROUPID
				}]
			},
			'relationshipStrength': {
				'results': [{
					'relationships': [],
					'id': GROUPID
				}],
				'predictStatus': predictStatusObject
			},
			'status': {
				'message': statusMsg,
				'statusCode': SmartsRecommenderStatus.COMPLETED
			}
		};
	}
}



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/relationshipGraph/DataBuilder.js